"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postRedirectUrlToParent = exports.setupIframeListener = exports.redirectInIframe = void 0;
let redirectIframe;
function getRedirectIframe() {
    if (typeof redirectIframe === "undefined") {
        redirectIframe = window.document.createElement("iframe");
        redirectIframe.setAttribute("hidden", "true");
        redirectIframe.setAttribute("sandbox", "allow-scripts allow-same-origin");
    }
    return redirectIframe;
}
function redirectInIframe(redirectUrl) {
    const iframe = getRedirectIframe();
    window.document.body.appendChild(iframe);
    iframe.src = redirectUrl;
}
exports.redirectInIframe = redirectInIframe;
function setupIframeListener(handleIframeRedirect) {
    if (typeof window === "undefined") {
        return;
    }
    window.addEventListener("message", async (evt) => {
        const iframe = getRedirectIframe();
        if (evt.origin === window.location.origin &&
            evt.source === iframe.contentWindow) {
            if (typeof evt.data.redirectUrl === "string") {
                await handleIframeRedirect(evt.data.redirectUrl);
            }
        }
        if (window.document.body.contains(iframe)) {
            window.document.body.removeChild(iframe);
        }
    });
}
exports.setupIframeListener = setupIframeListener;
function postRedirectUrlToParent(redirectUrl) {
    window.top.postMessage({
        redirectUrl,
    }, window.location.origin);
}
exports.postRedirectUrlToParent = postRedirectUrlToParent;
